import { useEffect, useState } from 'react';
import { useNavigate, redirect } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import GoogleButton from 'react-google-button'
import { Terms } from './signup'

import { AuthLayout } from '../catalyst/auth-layout'
import { Button } from '../catalyst/button'
import { ErrorMessage, Field, Label } from '../catalyst/fieldset'
import { Heading } from '../catalyst/heading'
import InputWithError from '../catalyst/custom/inputWithError'
import { Strong, Text, TextLink } from '../catalyst/text'
import { Logo } from '../logo'

import config from '../config';
import LanguageSelector from '../language/LanguageSelector';
import { Trans, useTranslation } from "react-i18next";
import Spinning from '../components/spinning';


// TODO remove, this demo shouldn't need to reset the theme.

export default function SignIn() {

    const navigate = useNavigate();

    const [errors, setErrors] = useState({});

    const [errResponse, setErrResponse] = useState("");

    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const params = new URLSearchParams(window.location.search);
    const [redirectMessage, setRedirectMessage] = useState(params.get('message'))
    const { t } = useTranslation(undefined, { keyPrefix: 'login' });
    // const {greeting} = t("greeting", {channel: "RoadsideCoder"});

    const [submitting, setSubmitting] = useState(false)


    useEffect(() => {

        if (localStorage.getItem("user") != null) {
            //Validate user token and route to dashboard, else clean usera

            const validateSession = async () => {
                try {
                    const response = await fetch(config.apiUrl + '/user/validateSession', {
                        headers: {
                            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
                        }
                    });
                    if (!response.ok) {
                        localStorage.removeItem('user');
                        localStorage.removeItem('logggedInAt');
                        throw new Error('Invalid token');
                    } else {
                        navigate(config.accountsPath);
                    }

                } catch (error) {

                }
            };


            validateSession();
        }
    }, []);



    const validate = (submittedFormData) => {
        let errors = {};


        if (!submittedFormData.email) {
            errors.email = t("emailRequired");
        } else if (!/\S+@\S+\.\S+/.test(submittedFormData.email)) {
            errors.email = t("emailInvalid");
        }

        if (!submittedFormData.password) {
            errors.password = t("passwordRequired");
        }

        return errors;
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        setErrResponse("")

        var formDataObj = new FormData(e.currentTarget);
        var newData = {
            email: formDataObj.get('email'),
            password: formDataObj.get('password')
        }

        const validationErrors = validate(newData);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setErrors({});
            setSubmitting(true)
            // Handle form submission (e.g., send data to backend)
            fetch(config.apiUrl + "/user/login", { // Replace with your actual endpoint
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newData)
            })
                .then(response => {
                    setSubmitting(false)
                    if (!response.ok) {
                        if (response.status === 400) {
                            return response.text().then(text => {
                                throw new Error(t(text));
                            });
                        }
                        throw new Error(t("errorLogin"));
                    }
                    return response.json();
                })
                .then(data => {
                    localStorage.setItem('user', JSON.stringify(data));
                    localStorage.setItem('logggedInAt', new Date().toISOString());
                    navigate(config.accountsPath)
                })
                .catch((error) => {
                    setSubmitting(false)
                    setErrResponse(error.message)
                    setErrors({});
                    console.error('Error:', error);
                });
        }

    };

    const googleLogin = useGoogleLogin({
        onSuccess: async tokenResponse => {
            navigate("/login/google/authenticate?code=" + tokenResponse.access_token)
        },
        // flow: 'implicit', // implicit is the default
    });

    return (

        <>

            <AuthLayout>
                <form onSubmit={handleSubmit} className="grid w-full max-w-sm grid-cols-1 gap-8">

                    <div className="flex flex-col items-center justify-center space-y-4">
                    <Logo className="h-6 text-zinc-950 dark:text-white forced-colors:text-[CanvasText]" redirectHome={true}/>
                        <GoogleButton onClick={() => googleLogin()} label="Login with Google"></GoogleButton>
                        {redirectMessage === "GAUTH_ERROR" ? <Field><ErrorMessage>{t("gAuthErr")}</ErrorMessage></Field> : <></>}
                        <Heading>{t("or")}</Heading>
                        <Heading>{t("title")}</Heading>
                        {/* <LanguageSelector></LanguageSelector> */}
                    </div>

                    <InputWithError error={errors.email} type="email" name="email" label={t("email")} onChange={()=>{}}/>
                    <InputWithError error={errors.password} type="password" name="password" label={t("password")} onChange={()=>{}}/>

                    <div className="flex items-center justify-between">
                        <Text className="ml-auto">
                            <TextLink href="forgotPassword">
                                <Strong>{t("forgotPassword")}</Strong>
                            </TextLink>
                        </Text>
                    </div>

                    {errResponse && <Field><ErrorMessage>{errResponse}</ErrorMessage></Field>}

                    {redirectMessage === "PASSWORD_UPDATED" ? <Field><ErrorMessage>{t("useNewPassword")}</ErrorMessage></Field> : <></>}

                    <Button type="submit" className="w-full cursor-pointer" disabled={submitting}>
                        {submitting ? <Spinning /> : t("login")}
                    </Button>

                    <Text>
                        {t("dontHaveAnAccount")}
                        {' '}
                        <TextLink href="signup">
                            <Strong>{t("signup")}</Strong>
                        </TextLink>
                    </Text>
                    <Terms></Terms>
                </form>
            </AuthLayout>
        </>


    );
}